import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  color: string;
  children: string;
  onClick: () => void;
  fontSize?: number;
  paddingSide?: number;
};

type StyleProps = {
  color: string;
  fontSize?: number;
  paddingSide?: number;
};

export const BorderButton: FC<Props> = ({ color, children, onClick, fontSize, paddingSide }) => {
  return (
    <Wrapper color={color} onClick={() => onClick()} fontSize={fontSize} paddingSide={paddingSide}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div<StyleProps>`
  padding: 0 ${(props) => props.paddingSide || 30}px;
  cursor: pointer;
  background: ${(props) => props.color};
  color: #fff;
  font-size: ${(props) => props.fontSize || 18}px;
  font-weight: bold;
  border: 3px solid #fff;
  height: 40px;
  border-radius: 23px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  text-align: center;
  line-height: 40px;

  align-items: center;
  display: flex;
  justify-content: center;

  &:hover {
    background: #fff;
    border-color: ${(props) => props.color};
    color: ${(props) => props.color};
  }
`;
